import { getTotalNumber } from '../totalMethod'
import timeutils from 'utils/wt-time-utils'
import { questionStatus, askAnswerTypes } from 'json/obs-department'
import { doctorLevels } from 'json/doctor-hospital'
import { getEnumeration } from 'enumeration'
export default {
  getAnswerPageByQuery (data) {
    let result = getTotalNumber(data)
    result.data.forEach(item => {
      let answererInfo = item.answererInfo || {}
      item.created_date = item.createdDate && timeutils.format(item.createdDate, 'date')
      item.ask_status = item.status && getEnumeration(item.status, questionStatus)
      answererInfo.position = answererInfo.positionCode && getEnumeration(answererInfo.positionCode, doctorLevels)
      item.lastModified_date = item.lastModifiedDate && timeutils.format(item.lastModifiedDate, 'date')
      item.expected_date = item.questionerExtendInfo && item.questionerExtendInfo.expectedDate && timeutils.format(item.questionerExtendInfo.expectedDate, 'date')
    })
    return result
  },
  getQstionAnswerDetail (data) {
    let mainQuestion = data.mainQuestion || {}
    let answererInfo = mainQuestion.answererInfo || {}
    let answerRecordList = data.answerRecordList || []
    answererInfo.position = answererInfo.positionCode && getEnumeration(answererInfo.positionCode, doctorLevels)
    mainQuestion.created_date = mainQuestion.createdDate && timeutils.format(mainQuestion.createdDate, 'date')
    mainQuestion.ask_status = mainQuestion.status && getEnumeration(mainQuestion.status, questionStatus)
    mainQuestion.expected_date = mainQuestion.questionerExtendInfo && mainQuestion.questionerExtendInfo.expectedDate &&
     timeutils.format(mainQuestion.questionerExtendInfo.expectedDate, 'date')
    answerRecordList.forEach(item => {
      item.record_type = askAnswerTypes[item.recordType]
      item.created_date = item.createdDate && timeutils.format(item.createdDate, 'date')
    })
    return data
  }
}
